var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"animate-spin h-5 w-5 mr-3 ...",attrs:{"viewBox":"0 0 24 24"}},[_vm._v("Login")])
}
var staticRenderFns = []

export { render, staticRenderFns }